'use strict';

angular.module('shiftTraderApp')
  .controller('FooterLeftCtrl', function ($scope, ServerUrls, $location, $rootScope, $uibModal, Session, Organizations,
                                          $timeout, Angularytics, UserPermissionsService) {
    $scope.state = {
      isInDrawMode: false,
      loggedIn: Session.isLoggedIn(),
      isInSandboxMode: null,
      showReferralOpen: false,
      showCFAForumOpen: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'shift_templates.view',
      'shift_templates.create',
      'work_periods.publish',
      'ui.scheduling.view_review_week',
      'ui.scheduling.view_allocations',
      'referral_actions.use',
      'account_transactions.view',
      'ui.view_forum'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canOpenManageTemplates: rawPerms['shift_templates.view'] && rawPerms['shift_templates.create'],
        canCreateTemplate: rawPerms['shift_templates.create'],
        canPublish: rawPerms['work_periods.publish'],
        canShowReviewWeek: rawPerms['ui.scheduling.view_review_week'],
        canShowAllocations: rawPerms['ui.scheduling.view_allocations'],
        canViewReferrals: rawPerms['referral_actions.use'] && rawPerms['account_transactions.view'],
        canViewForum: rawPerms['ui.view_forum']
      };
    }


    function calcPermissions() {
      UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
        .then(function(dikt) {
          $scope.state.rawPermissions = dikt;

          processRawPermissions();
        });
    }

    $scope.me = Session.me;
    // loggedIn var describes whether there is a logged-in user currently using the site

    $scope.$on('updatedSessionMe', function(event, isLoggedIn) {
      if (isLoggedIn) {
        $scope.me = Session.me;
        calcPermissions();
      }
    });

    $scope.$on('loginStateChanged', function(event, data) {
      $scope.state.loggedIn = data.state;
    });

    $scope.$on('$locationChangeSuccess', function () {
      $scope.state.isInDrawMode = false;
      calcPermissions();

      if(/^\/manageWorkPeriods/.test($location.path())) {
        $scope.manageWorkPeriods = true;
      } else {
        $scope.manageWorkPeriods = false;
      }
    });
    $scope.$on('sa:manageWorkPeriods:setEditDrawMode', function(event, val) {
      $scope.state.isInDrawMode = val;
    });

    $scope.$on('sa:manageWorkPeriod:dateChange', function(event, newDate) {
      //console.log('sa:manageWorkPeriod:dateChange', newDate.format());
      $scope.currentDate = newDate;
    });

    $scope.$on('sa:manageWorkPeriod:WorkPeriodStoreUpdated', function(event, newDate) {
      //console.log('$ON footerLeft: sa:manageWorkPeriod:WorkPeriodStoreUpdated', newDate.format());
      $scope.currentDate = newDate;
    });

    $scope.$on('sa:manageWorkPeriod:WeekPublishDataUpdated', function(event, publishData) {
      //console.log('sa:manageWorkPeriod:WeekPublishDataUpdated', publishData);
      //console.log(publishData);
      $scope.dayAnalysisDataByDay = publishData;
      //console.log('dayAnalysisDataByDay from FooterLeft');
      //console.log($scope.dayAnalysisDataByDay);
    });

    $scope.$on('sa:manageWorkPeriod:DayIndexUpdated', function(event, dayIndex) {
      //console.log('sa:manageWorkPeriod:DayIndexUpdated', dayIndex);
      $scope.dayIndex = dayIndex;
    });

    $scope.$on('sa:manageWorkPeriod:selectedTemplateChange', function(event, selectedTemplate) {
      $scope.selectedTemplate = selectedTemplate;
    });



    $scope.publishDay = function () {
      $rootScope.$broadcast('publishDay');
    };

    $scope.publishWeek = function() {
      $rootScope.$broadcast('publishWeek');
    };

    $scope.openNewTemplateModal = function() {
      $rootScope.$broadcast('sa:manageWorkPeriod:openNewTemplateModal');
    };

    $scope.openManageTemplatesModal = function() {
      $rootScope.$broadcast('sa:manageWorkPeriod:openManageTemplatesModal');
    };

    $scope.openWeekReviewModal = function() {
      $rootScope.$broadcast('sa:manageWorkPeriod:openWeekReviewModal');
    };

    $scope.openEmployeeListModal = function() {
      $rootScope.$broadcast('sa:manageWorkPeriod:openEmployeeListModal');
    };

    $scope.openDrawModeInfoModal = function() {
      var modalInstance = $uibModal.open({
        size: 'wide',
        templateUrl: 'views/drawModeExplainedModal.html',
        controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
          $scope.close = function() {
            $uibModalInstance.dismiss('close');
          };
        }]
      });
    };


    $scope.openReferralModal = function() {
      if (!$scope.state.showReferralOpen) {
        return false;
      }

      Angularytics.trackEvent('Referrals', 'footer-modal-open', $scope.me.memberships[0].organization.name, $scope.me.memberships[0].organization.id);

      var modalInstance = $uibModal.open({
        templateUrl: 'views/referralsModal.html',
        controller: 'ReferralsModalCtrl',
        size: 'full',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          params: function() {
            return {
              me: $scope.me
            };
          },
          org: ['Organizations', function(Organizations) {
            return Organizations.getCurrentOrg();
          }],
          accountTransactions: ['AccountTransactions', function (AccountTransactions) {
            return AccountTransactions.getByOrgId(Session.getCurrentOrgId());
          }],
          referralActions: ['ReferralActions', function (ReferralActions) {
            return ReferralActions.getByOrgId(Session.getCurrentOrgId());
          }],
          myStore: ['Organizations', function(Organizations) {
            var currentOrg = Organizations.initWithData(lodash.find($scope.me.memberships, {current: true}).organization);
            return currentOrg.$getStore();
          }]
        }
      });
      modalInstance.result.then(function(result) {
          console.log('closed referrals modal with result' + result);
        },
        function(reason) {
          console.log('dismissed explanation with reason ' + reason);
        });
    };
  });
